// library
import { ArGrid } from '@aceroll/core/library';

// hacksaw
import { currencyService } from '@aceroll/core';


export class Grid extends ArGrid {
    stickySymbols = new Map();

    respinTriggerCount = null;
    respinCounter = null;

    async playRespinTrigger(_name, count) {
        this.respinTriggerCount = count;
    }

    async updateRespinCounter(count) {
        if (this.respinCounter && this.respinCounter.updateCounter) {
            this.respinCounter.updateCounter(count);
        }
    }

    async playMultiplier(action) {
        const { data } = action;
        const { position, value } = data;
        const { reel, row } = position;

        const symbol = this.symbols[reel][row];

        if (symbol.multiply) {
            return symbol.multiply(value, row);
        }

    }

    async playGroupWin(groups) {
        for (let i = 0; i < groups.length; i++) {
            const { baseTotalWin, totalWin, multiplier, positions, symbolId } = groups[i];

            this.repositionWinText(positions);

            await Promise.all([
                this.processWinLine(positions, i, symbolId),
                this.showWinFormulaText(`${currencyService.toMoney(baseTotalWin)}X${multiplier}`),
                this.showWinText(`${currencyService.toMoney(totalWin)}`)
            ]);
        }
    }

    async playWin(positions) {

        const dimAll = [];
        for (let k = 0; k < this.symbols.length; k++) {
            const dimReel = this.symbols[k];
            for (let j = 0; j < dimReel.length; j++) {
                const dimSymbol = dimReel[j];
                dimAll.push(dimSymbol.dimmIn(0));
            }
        }
        await Promise.all(dimAll);

        const animations = [];
        for (let i = 0; i < positions.length; i++) {
            const position = positions[i];
            const { reel, row } = position;
            const symbol = this.symbols[reel][row];
            symbol.zIndex += symbol.overMask ? 100 : 200;
            animations.push(symbol.win());
        }
        return Promise.all(animations).then((data) => {
            for (let i = 0; i < positions.length; i++) {
                const position = positions[i];
                const { reel, row } = position;
                const symbol = this.symbols[reel][row];
                symbol.zIndex -= symbol.overMask ? 100 : 200;
                symbol.static();
            }
            return data;
        });

        // this.processWinLine(positions);
    }

    updateSymbols(initial = false) {
        super.updateSymbols(initial);
    }

    async stick(positions) {
        for (let i = 0; i < positions.length; i++) {
            const { reel, row } = positions[i];

            const symbol = this.symbols[reel][row];

            const stickySymbol = this.getSymbol(symbol.id);

            const { position, size } = this.symbolsTransforms[reel][row];

            stickySymbol.position.set(position.x, position.y);
            stickySymbol.pivot.set(size.width / 2, size.height / 2);
            stickySymbol.setTransforms(this.symbolsTransforms[reel][row]);
            stickySymbol.zIndex = 50;
            this.addChild(stickySymbol);

            this.stickySymbols.set(`${reel}-${row}`, stickySymbol);

            if (!stickySymbol.stick) {
                continue;
            }

            await stickySymbol.stick(this.respinTriggerCount);
            this.respinCounter = stickySymbol;
            this.respinTriggerCount = null;
        }
    }

    unstick(positions) {
        for (let i = 0; i < positions.length; i++) {
            const { reel, row } = positions[i];

            const stickySymbol = this.stickySymbols.get(`${reel}-${row}`);
            stickySymbol.zIndex = stickySymbol.overMask ? 2 : 1;
            this.putSymbol(stickySymbol);
            this.stickySymbols.delete(`${reel}-${row}`);
        }

        this.respinCounter = null;
    }

    unstickAll() {
        this.stickySymbols.forEach(stickySymbol => {
            this.putSymbol(stickySymbol);
        });

        this.stickySymbols.clear();
        this.respinCounter = null;
    }

    expand(position, multiplier) {
        const { reel, row } = position;
        const expandSymbol = this.symbols[reel][row];

        return expandSymbol.expand(multiplier).then(() => {
            // when expanded hide all non expand symbols behind
            for (let i = 0; i < this.symbols[reel].length; i++) {
                if (i === row) { continue; }
                this.symbols[reel][i].visible = false;
            }
        });
    }

    stop() {
        for (let k = 0; k < this.symbols.length; k++) {
            const reel = this.symbols[k];
            for (let j = 0; j < reel.length; j++) {
                const symbol = reel[j];

                if (symbol.spine && symbol.spine.running) {
                    symbol.spine.stop(false);
                }
                symbol.static();
            }
        }
        this.text.renderable = false;
        this.winFormulaText.renderable = false;
    }

    repositionWinText(positions) {
        this.text.renderable = true;
        this.winFormulaText.renderable = true;

        this.text.pivot.set(0, 38);
        this.winFormulaText.pivot.set(0, 38);
        super.repositionWinText(positions);


        // const { width, height } = this.config.cellsSize;

        // this.text.position.set(466, 385);
        // this.winFormulaText.position.set(466, 385);
    }
}
